import { BaSeIcon, BaSeSmall1 } from '@base/react';
import React from 'react';
import { Field, Title } from './characteristics-entrepreneur-style';
import Detail from './detail';

function RowInfo({ color, title, description, typeIcon }) {
  const iconName = `system/arrow-${typeIcon}-fill`;
  return (
    <Field>
      <Title>
        <BaSeIcon
          color={color}
          description="system/arrow-up-fill"
          name={iconName}
          size={16}
        />
        <BaSeSmall1 color="#636363">{title}</BaSeSmall1>
      </Title>

      <Detail description={description} />
    </Field>
  );
}

export default RowInfo;
